"use strict";
// By Drew Colthorp, <https://spin.atomicobject.com/2018/01/15/typescript-flexible-nominal-typing/#comment-604580>
// <https://gist.github.com/dcolthorp/aa21cf87d847ae9942106435bf47565d>
Object.defineProperty(exports, "__esModule", { value: true });
function createBrandCreator() {
    return function (value) {
        return value;
    };
}
exports.createBrandCreator = createBrandCreator;
//# sourceMappingURL=Brand.js.map